/*
THIS COMPONENT INCLUDING IN ALL ADMIN PAGES
 ---------------------------------------------*/
import 'datepicker';
import 'datetimepicker';

let DatePickerManager = (() => {
    let init = () => {
        initDatePicker();
        initDateTimePicker();
    };

    let initDatePicker = () => {
        $('input[name="created_at"]').datepicker({
            language: 'ru',
            format: 'dd.mm.yyyy'
        });

        $('.datepicker').datepicker({
            timePickerIncrement: 30,
            format: 'dd.mm.yyyy'
        });

        $('#datepicker_start').datepicker({
            timePickerIncrement: 30,
            format: 'dd.mm.yyyy',
            endDate: 'dateToday'
        }).change(function () {
            let startDate = $(this).val();
            $('#datepicker_finish').val('').datepicker('remove').datepicker({
                format: 'dd.mm.yyyy',
                startDate: startDate,
                endDate: 'dateToday'
            });
        });

        $('#datepicker_finish').datepicker({
            timePickerIncrement: 30,
            format: 'dd.mm.yyyy',
            endDate: 'dateToday'
        });
    };

    let initDateTimePicker = () => {
        $('#datetimepicker_start').datetimepicker({
            todayBtn: true,
            minuteStep: 60,
            autoclose: true,
            format: 'yyyy-mm-dd hh:ii',
        }).change(function () {
            let startDate = $(this).val();
            $('#datetimepicker_finish').val('').datetimepicker('remove').datetimepicker({
                todayBtn: true,
                minuteStep: 60,
                autoclose: true,
                format: 'yyyy-mm-dd hh:ii',
            });
        });

        $('#datetimepicker_finish').datetimepicker({
            todayBtn: true,
            minuteStep: 60,
            autoclose: true,
            endDate: new Date(),
            format: 'yyyy-mm-dd hh:ii',
        });

        $('.publication_date').datetimepicker({
            todayBtn: true,
            minuteStep: 5,
            autoclose: true,
            format: 'dd.mm.yyyy hh:ii',
        });
    };

    return {
        init: init
    };
})();

export default DatePickerManager;




